(ns app.front.view.admin.commands.remove-duplicate-user
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::remove-user
  (fn [_ [_ username-to-be-removed username-to-be-retained]]
    {:comm/command {:command :admin/remove-duplicate-user
                    :method  :post
                    :data    {:username-to-be-removed  username-to-be-removed
                              :username-to-be-retained username-to-be-retained}
                    :notify  {:success "Duplicate user removed"}}}))

(defn view [match]
  [acommon/admin-page-v2 (util/mmap {:title "Remove duplicate user"} match)
   [:section
    [:div
     [ui/help "In case a duplicate user is registered, this tool can be used to remove the one that has been created later.
               The requirements for removable user are as follow:
               - Local part of users' email addresses must match (that is, the part before the @ sign)
               - The user to be removed must be the one created later
               - The user to be removed must not belong to any user groups
               - The user to be removed must not be linked to any parties
               - The user to be removed must not be linked to any invites"]]]
   (r/with-let [*username-to-be-removed (r/atom nil)
                *username-to-be-retained (r/atom nil)]
     [:section
      [:div.p-6
       [ui/text-input {:id          "removed-username-id"
                       :light       true
                       :value       @*username-to-be-removed
                       :required    true
                       :on-change   #(reset! *username-to-be-removed (futil/tval %))
                       :placeholder "Username"
                       :label-text  "Username of the user to be removed."}]]
      [:div.p-6
       [ui/text-input {:id          "retainer-username-id"
                       :light       true
                       :value       @*username-to-be-retained
                       :required    true
                       :on-change   #(reset! *username-to-be-retained (futil/tval %))
                       :placeholder "Username"
                       :label-text  "Username of the user to be retained."}]]
      [:div.p-6
       (cc/button {:kind     :primary
                   :disabled (or (nil? @*username-to-be-removed)
                                 (nil? @*username-to-be-retained)
                                 (= @*username-to-be-removed @*username-to-be-retained))
                   :on-click #(>evt [::remove-user @*username-to-be-removed @*username-to-be-retained])}
                  "Remove duplicate entity")]])])

(def route
  {:name        :view/admin.commands.remove-duplicate-user
   :own-layout? true
   :view        view})
